import React, { useState } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import ForgotPasswordForm from './ForgotPasswordForm'
import { useSelector } from 'react-redux'
import SlidingPane from 'react-sliding-pane'
import { isMobileDevice } from '../../helpers'
export const ForgotPasswordPane = (props) => {
  const [isPaneOpen, setIsPaneOpen] = useState(false)
  const { productName } = useSelector((state) => state.application)
  const [successResponse, setSuccessResponse] = useState(null)

  const onSuccess = (response) => {
    setSuccessResponse(response)
  }

  return (
    <>
      <ReactBootstrap.Button
        variant="link"
        className="text-dark btn-sm"
        onClick={(e) => {
          e.stopPropagation()
          setIsPaneOpen(true)
        }}
      >
        Forgot Password ?
      </ReactBootstrap.Button>
      <SlidingPane
        width={isMobileDevice ? '100vw' : '400px'}
        overlayClassName="on-top"
        isOpen={isPaneOpen}
        title={`Reset Password for ${productName}`}
        onRequestClose={() => {
          setIsPaneOpen(false)
        }}
      >
        <>
          {!successResponse ? (
            <>
              <ReactBootstrap.Row>
                <ReactBootstrap.Col xs={12}>
                  <h5 className="text-justify p-0">
                    Enter your user account's verified email address and we will
                    send you a password reset link.
                  </h5>
                </ReactBootstrap.Col>
                <ReactBootstrap.Col xs={12}>
                  <ReactBootstrap.Col className={'p-3'}>
                    {' '}
                    <ForgotPasswordForm onSuccess={onSuccess} />{' '}
                  </ReactBootstrap.Col>
                </ReactBootstrap.Col>
              </ReactBootstrap.Row>
            </>
          ) : (
            <div className="p-0">
              {successResponse && (
                <ReactBootstrap.Alert variant="success">
                  {successResponse.detail}
                </ReactBootstrap.Alert>
              )}
            </div>
          )}
        </>
      </SlidingPane>
    </>
  )
}
